/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as WallRouteImport } from './routes/wall'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAlertsRouteImport } from './routes/_app/alerts'
import { Route as AppAuditRouteImport } from './routes/_app/audit'
import { Route as AppCountriesRouteImport } from './routes/_app/countries'
import { Route as AppExportsRouteImport } from './routes/_app/exports'
import { Route as AppFeesRouteImport } from './routes/_app/fees'
import { Route as AppLimitsRouteImport } from './routes/_app/limits'
import { Route as AppMoneyRouteImport } from './routes/_app/money'
import { Route as AppNoticesRouteImport } from './routes/_app/notices'
import { Route as AppReferralRewardsRouteImport } from './routes/_app/referral-rewards'
import { Route as AppReferralsRouteImport } from './routes/_app/referrals'
import { Route as AppRegistryRouteImport } from './routes/_app/registry'
import { Route as AppSecurityRouteImport } from './routes/_app/security'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppSwitchesRouteImport } from './routes/_app/switches'
import { Route as AppTiersRouteImport } from './routes/_app/tiers'
import { Route as AppVerificationsRouteImport } from './routes/_app/verifications'
import { Route as WallIndexRouteImport } from './routes/wall/index'
import { Route as WallContactRouteImport } from './routes/wall/contact'
import { Route as WallSocRouteImport } from './routes/wall/soc'
import { Route as AppApprovalsIndexRouteImport } from './routes/_app/approvals/index'
import { Route as AppApprovalsRequestIdRouteImport } from './routes/_app/approvals/$requestId'
import { Route as AppCasesIndexRouteImport } from './routes/_app/cases/index'
import { Route as AppCasesCaseIdRouteImport } from './routes/_app/cases/$caseId'
import { Route as AppChangesIndexRouteImport } from './routes/_app/changes/index'
import { Route as AppChangesRequestIdRouteImport } from './routes/_app/changes/$requestId'
import { Route as AppCustomersIndexRouteImport } from './routes/_app/customers/index'
import { Route as AppCustomersCustomerIdRouteImport } from './routes/_app/customers/$customerId'
import { Route as AppIssuesIndexRouteImport } from './routes/_app/issues/index'
import { Route as AppIssuesIssueIdRouteImport } from './routes/_app/issues/$issueId'
import { Route as AppPartnersIndexRouteImport } from './routes/_app/partners/index'
import { Route as AppPartnersPartnerIdRouteImport } from './routes/_app/partners/$partnerId'
import { Route as AppStaffIndexRouteImport } from './routes/_app/staff/index'
import { Route as AppStaffStaffIdRouteImport } from './routes/_app/staff/$staffId'
import { Route as AppTransactionsIndexRouteImport } from './routes/_app/transactions/index'
import { Route as AppTransactionsTransactionIdRouteImport } from './routes/_app/transactions/$transactionId'
import { Route as AppCustomersCreditWalletIdRouteImport } from './routes/_app/customers/credit.$walletId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const WallRoute = WallRouteImport.update({
  id: '/wall',
  path: '/wall',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAlertsRoute = AppAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditRoute = AppAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppCountriesRoute = AppCountriesRouteImport.update({
  id: '/countries',
  path: '/countries',
  getParentRoute: () => AppRoute,
} as any)
const AppExportsRoute = AppExportsRouteImport.update({
  id: '/exports',
  path: '/exports',
  getParentRoute: () => AppRoute,
} as any)
const AppFeesRoute = AppFeesRouteImport.update({
  id: '/fees',
  path: '/fees',
  getParentRoute: () => AppRoute,
} as any)
const AppLimitsRoute = AppLimitsRouteImport.update({
  id: '/limits',
  path: '/limits',
  getParentRoute: () => AppRoute,
} as any)
const AppMoneyRoute = AppMoneyRouteImport.update({
  id: '/money',
  path: '/money',
  getParentRoute: () => AppRoute,
} as any)
const AppNoticesRoute = AppNoticesRouteImport.update({
  id: '/notices',
  path: '/notices',
  getParentRoute: () => AppRoute,
} as any)
const AppReferralRewardsRoute = AppReferralRewardsRouteImport.update({
  id: '/referral-rewards',
  path: '/referral-rewards',
  getParentRoute: () => AppRoute,
} as any)
const AppReferralsRoute = AppReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => AppRoute,
} as any)
const AppRegistryRoute = AppRegistryRouteImport.update({
  id: '/registry',
  path: '/registry',
  getParentRoute: () => AppRoute,
} as any)
const AppSecurityRoute = AppSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSwitchesRoute = AppSwitchesRouteImport.update({
  id: '/switches',
  path: '/switches',
  getParentRoute: () => AppRoute,
} as any)
const AppTiersRoute = AppTiersRouteImport.update({
  id: '/tiers',
  path: '/tiers',
  getParentRoute: () => AppRoute,
} as any)
const AppVerificationsRoute = AppVerificationsRouteImport.update({
  id: '/verifications',
  path: '/verifications',
  getParentRoute: () => AppRoute,
} as any)
const WallIndexRoute = WallIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WallRoute,
} as any)
const WallContactRoute = WallContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => WallRoute,
} as any)
const WallSocRoute = WallSocRouteImport.update({
  id: '/soc',
  path: '/soc',
  getParentRoute: () => WallRoute,
} as any)
const AppApprovalsIndexRoute = AppApprovalsIndexRouteImport.update({
  id: '/approvals/',
  path: '/approvals/',
  getParentRoute: () => AppRoute,
} as any)
const AppApprovalsRequestIdRoute = AppApprovalsRequestIdRouteImport.update({
  id: '/approvals/$requestId',
  path: '/approvals/$requestId',
  getParentRoute: () => AppRoute,
} as any)
const AppCasesIndexRoute = AppCasesIndexRouteImport.update({
  id: '/cases/',
  path: '/cases/',
  getParentRoute: () => AppRoute,
} as any)
const AppCasesCaseIdRoute = AppCasesCaseIdRouteImport.update({
  id: '/cases/$caseId',
  path: '/cases/$caseId',
  getParentRoute: () => AppRoute,
} as any)
const AppChangesIndexRoute = AppChangesIndexRouteImport.update({
  id: '/changes/',
  path: '/changes/',
  getParentRoute: () => AppRoute,
} as any)
const AppChangesRequestIdRoute = AppChangesRequestIdRouteImport.update({
  id: '/changes/$requestId',
  path: '/changes/$requestId',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIndexRoute = AppCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersCustomerIdRoute = AppCustomersCustomerIdRouteImport.update({
  id: '/customers/$customerId',
  path: '/customers/$customerId',
  getParentRoute: () => AppRoute,
} as any)
const AppIssuesIndexRoute = AppIssuesIndexRouteImport.update({
  id: '/issues/',
  path: '/issues/',
  getParentRoute: () => AppRoute,
} as any)
const AppIssuesIssueIdRoute = AppIssuesIssueIdRouteImport.update({
  id: '/issues/$issueId',
  path: '/issues/$issueId',
  getParentRoute: () => AppRoute,
} as any)
const AppPartnersIndexRoute = AppPartnersIndexRouteImport.update({
  id: '/partners/',
  path: '/partners/',
  getParentRoute: () => AppRoute,
} as any)
const AppPartnersPartnerIdRoute = AppPartnersPartnerIdRouteImport.update({
  id: '/partners/$partnerId',
  path: '/partners/$partnerId',
  getParentRoute: () => AppRoute,
} as any)
const AppStaffIndexRoute = AppStaffIndexRouteImport.update({
  id: '/staff/',
  path: '/staff/',
  getParentRoute: () => AppRoute,
} as any)
const AppStaffStaffIdRoute = AppStaffStaffIdRouteImport.update({
  id: '/staff/$staffId',
  path: '/staff/$staffId',
  getParentRoute: () => AppRoute,
} as any)
const AppTransactionsIndexRoute = AppTransactionsIndexRouteImport.update({
  id: '/transactions/',
  path: '/transactions/',
  getParentRoute: () => AppRoute,
} as any)
const AppTransactionsTransactionIdRoute =
  AppTransactionsTransactionIdRouteImport.update({
    id: '/transactions/$transactionId',
    path: '/transactions/$transactionId',
    getParentRoute: () => AppRoute,
  } as any)
const AppCustomersCreditWalletIdRoute =
  AppCustomersCreditWalletIdRouteImport.update({
    id: '/customers/credit/$walletId',
    path: '/customers/credit/$walletId',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/set-password': typeof SetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/wall': typeof WallRouteWithChildren
  '/alerts': typeof AppAlertsRoute
  '/audit': typeof AppAuditRoute
  '/countries': typeof AppCountriesRoute
  '/exports': typeof AppExportsRoute
  '/fees': typeof AppFeesRoute
  '/limits': typeof AppLimitsRoute
  '/money': typeof AppMoneyRoute
  '/notices': typeof AppNoticesRoute
  '/referral-rewards': typeof AppReferralRewardsRoute
  '/referrals': typeof AppReferralsRoute
  '/registry': typeof AppRegistryRoute
  '/security': typeof AppSecurityRoute
  '/settings': typeof AppSettingsRoute
  '/switches': typeof AppSwitchesRoute
  '/tiers': typeof AppTiersRoute
  '/verifications': typeof AppVerificationsRoute
  '/wall/contact': typeof WallContactRoute
  '/wall/soc': typeof WallSocRoute
  '/wall/': typeof WallIndexRoute
  '/approvals/$requestId': typeof AppApprovalsRequestIdRoute
  '/cases/$caseId': typeof AppCasesCaseIdRoute
  '/changes/$requestId': typeof AppChangesRequestIdRoute
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/issues/$issueId': typeof AppIssuesIssueIdRoute
  '/partners/$partnerId': typeof AppPartnersPartnerIdRoute
  '/staff/$staffId': typeof AppStaffStaffIdRoute
  '/transactions/$transactionId': typeof AppTransactionsTransactionIdRoute
  '/approvals/': typeof AppApprovalsIndexRoute
  '/cases/': typeof AppCasesIndexRoute
  '/changes/': typeof AppChangesIndexRoute
  '/customers/': typeof AppCustomersIndexRoute
  '/issues/': typeof AppIssuesIndexRoute
  '/partners/': typeof AppPartnersIndexRoute
  '/staff/': typeof AppStaffIndexRoute
  '/transactions/': typeof AppTransactionsIndexRoute
  '/customers/credit/$walletId': typeof AppCustomersCreditWalletIdRoute
}
export interface FileRoutesByTo {
  '/set-password': typeof SetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/alerts': typeof AppAlertsRoute
  '/audit': typeof AppAuditRoute
  '/countries': typeof AppCountriesRoute
  '/exports': typeof AppExportsRoute
  '/fees': typeof AppFeesRoute
  '/limits': typeof AppLimitsRoute
  '/money': typeof AppMoneyRoute
  '/notices': typeof AppNoticesRoute
  '/referral-rewards': typeof AppReferralRewardsRoute
  '/referrals': typeof AppReferralsRoute
  '/registry': typeof AppRegistryRoute
  '/security': typeof AppSecurityRoute
  '/settings': typeof AppSettingsRoute
  '/switches': typeof AppSwitchesRoute
  '/tiers': typeof AppTiersRoute
  '/verifications': typeof AppVerificationsRoute
  '/wall/contact': typeof WallContactRoute
  '/wall/soc': typeof WallSocRoute
  '/': typeof AppIndexRoute
  '/wall': typeof WallIndexRoute
  '/approvals/$requestId': typeof AppApprovalsRequestIdRoute
  '/cases/$caseId': typeof AppCasesCaseIdRoute
  '/changes/$requestId': typeof AppChangesRequestIdRoute
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/issues/$issueId': typeof AppIssuesIssueIdRoute
  '/partners/$partnerId': typeof AppPartnersPartnerIdRoute
  '/staff/$staffId': typeof AppStaffStaffIdRoute
  '/transactions/$transactionId': typeof AppTransactionsTransactionIdRoute
  '/approvals': typeof AppApprovalsIndexRoute
  '/cases': typeof AppCasesIndexRoute
  '/changes': typeof AppChangesIndexRoute
  '/customers': typeof AppCustomersIndexRoute
  '/issues': typeof AppIssuesIndexRoute
  '/partners': typeof AppPartnersIndexRoute
  '/staff': typeof AppStaffIndexRoute
  '/transactions': typeof AppTransactionsIndexRoute
  '/customers/credit/$walletId': typeof AppCustomersCreditWalletIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/set-password': typeof SetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/wall': typeof WallRouteWithChildren
  '/_app/alerts': typeof AppAlertsRoute
  '/_app/audit': typeof AppAuditRoute
  '/_app/countries': typeof AppCountriesRoute
  '/_app/exports': typeof AppExportsRoute
  '/_app/fees': typeof AppFeesRoute
  '/_app/limits': typeof AppLimitsRoute
  '/_app/money': typeof AppMoneyRoute
  '/_app/notices': typeof AppNoticesRoute
  '/_app/referral-rewards': typeof AppReferralRewardsRoute
  '/_app/referrals': typeof AppReferralsRoute
  '/_app/registry': typeof AppRegistryRoute
  '/_app/security': typeof AppSecurityRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/switches': typeof AppSwitchesRoute
  '/_app/tiers': typeof AppTiersRoute
  '/_app/verifications': typeof AppVerificationsRoute
  '/wall/contact': typeof WallContactRoute
  '/wall/soc': typeof WallSocRoute
  '/_app/': typeof AppIndexRoute
  '/wall/': typeof WallIndexRoute
  '/_app/approvals/$requestId': typeof AppApprovalsRequestIdRoute
  '/_app/cases/$caseId': typeof AppCasesCaseIdRoute
  '/_app/changes/$requestId': typeof AppChangesRequestIdRoute
  '/_app/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/_app/issues/$issueId': typeof AppIssuesIssueIdRoute
  '/_app/partners/$partnerId': typeof AppPartnersPartnerIdRoute
  '/_app/staff/$staffId': typeof AppStaffStaffIdRoute
  '/_app/transactions/$transactionId': typeof AppTransactionsTransactionIdRoute
  '/_app/approvals/': typeof AppApprovalsIndexRoute
  '/_app/cases/': typeof AppCasesIndexRoute
  '/_app/changes/': typeof AppChangesIndexRoute
  '/_app/customers/': typeof AppCustomersIndexRoute
  '/_app/issues/': typeof AppIssuesIndexRoute
  '/_app/partners/': typeof AppPartnersIndexRoute
  '/_app/staff/': typeof AppStaffIndexRoute
  '/_app/transactions/': typeof AppTransactionsIndexRoute
  '/_app/customers/credit/$walletId': typeof AppCustomersCreditWalletIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/set-password'
    | '/sign-in'
    | '/wall'
    | '/alerts'
    | '/audit'
    | '/countries'
    | '/exports'
    | '/fees'
    | '/limits'
    | '/money'
    | '/notices'
    | '/referral-rewards'
    | '/referrals'
    | '/registry'
    | '/security'
    | '/settings'
    | '/switches'
    | '/tiers'
    | '/verifications'
    | '/wall/contact'
    | '/wall/soc'
    | '/wall/'
    | '/approvals/$requestId'
    | '/cases/$caseId'
    | '/changes/$requestId'
    | '/customers/$customerId'
    | '/issues/$issueId'
    | '/partners/$partnerId'
    | '/staff/$staffId'
    | '/transactions/$transactionId'
    | '/approvals/'
    | '/cases/'
    | '/changes/'
    | '/customers/'
    | '/issues/'
    | '/partners/'
    | '/staff/'
    | '/transactions/'
    | '/customers/credit/$walletId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/set-password'
    | '/sign-in'
    | '/alerts'
    | '/audit'
    | '/countries'
    | '/exports'
    | '/fees'
    | '/limits'
    | '/money'
    | '/notices'
    | '/referral-rewards'
    | '/referrals'
    | '/registry'
    | '/security'
    | '/settings'
    | '/switches'
    | '/tiers'
    | '/verifications'
    | '/wall/contact'
    | '/wall/soc'
    | '/'
    | '/wall'
    | '/approvals/$requestId'
    | '/cases/$caseId'
    | '/changes/$requestId'
    | '/customers/$customerId'
    | '/issues/$issueId'
    | '/partners/$partnerId'
    | '/staff/$staffId'
    | '/transactions/$transactionId'
    | '/approvals'
    | '/cases'
    | '/changes'
    | '/customers'
    | '/issues'
    | '/partners'
    | '/staff'
    | '/transactions'
    | '/customers/credit/$walletId'
  id:
    | '__root__'
    | '/_app'
    | '/set-password'
    | '/sign-in'
    | '/wall'
    | '/_app/alerts'
    | '/_app/audit'
    | '/_app/countries'
    | '/_app/exports'
    | '/_app/fees'
    | '/_app/limits'
    | '/_app/money'
    | '/_app/notices'
    | '/_app/referral-rewards'
    | '/_app/referrals'
    | '/_app/registry'
    | '/_app/security'
    | '/_app/settings'
    | '/_app/switches'
    | '/_app/tiers'
    | '/_app/verifications'
    | '/wall/contact'
    | '/wall/soc'
    | '/_app/'
    | '/wall/'
    | '/_app/approvals/$requestId'
    | '/_app/cases/$caseId'
    | '/_app/changes/$requestId'
    | '/_app/customers/$customerId'
    | '/_app/issues/$issueId'
    | '/_app/partners/$partnerId'
    | '/_app/staff/$staffId'
    | '/_app/transactions/$transactionId'
    | '/_app/approvals/'
    | '/_app/cases/'
    | '/_app/changes/'
    | '/_app/customers/'
    | '/_app/issues/'
    | '/_app/partners/'
    | '/_app/staff/'
    | '/_app/transactions/'
    | '/_app/customers/credit/$walletId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  SetPasswordRoute: typeof SetPasswordRoute
  SignInRoute: typeof SignInRoute
  WallRoute: typeof WallRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wall': {
      id: '/wall'
      path: '/wall'
      fullPath: '/wall'
      preLoaderRoute: typeof WallRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/alerts': {
      id: '/_app/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AppAlertsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit': {
      id: '/_app/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AppAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/countries': {
      id: '/_app/countries'
      path: '/countries'
      fullPath: '/countries'
      preLoaderRoute: typeof AppCountriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/exports': {
      id: '/_app/exports'
      path: '/exports'
      fullPath: '/exports'
      preLoaderRoute: typeof AppExportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fees': {
      id: '/_app/fees'
      path: '/fees'
      fullPath: '/fees'
      preLoaderRoute: typeof AppFeesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/limits': {
      id: '/_app/limits'
      path: '/limits'
      fullPath: '/limits'
      preLoaderRoute: typeof AppLimitsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/money': {
      id: '/_app/money'
      path: '/money'
      fullPath: '/money'
      preLoaderRoute: typeof AppMoneyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notices': {
      id: '/_app/notices'
      path: '/notices'
      fullPath: '/notices'
      preLoaderRoute: typeof AppNoticesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/referral-rewards': {
      id: '/_app/referral-rewards'
      path: '/referral-rewards'
      fullPath: '/referral-rewards'
      preLoaderRoute: typeof AppReferralRewardsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/referrals': {
      id: '/_app/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof AppReferralsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/registry': {
      id: '/_app/registry'
      path: '/registry'
      fullPath: '/registry'
      preLoaderRoute: typeof AppRegistryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/security': {
      id: '/_app/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof AppSecurityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/switches': {
      id: '/_app/switches'
      path: '/switches'
      fullPath: '/switches'
      preLoaderRoute: typeof AppSwitchesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tiers': {
      id: '/_app/tiers'
      path: '/tiers'
      fullPath: '/tiers'
      preLoaderRoute: typeof AppTiersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/verifications': {
      id: '/_app/verifications'
      path: '/verifications'
      fullPath: '/verifications'
      preLoaderRoute: typeof AppVerificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/wall/': {
      id: '/wall/'
      path: '/'
      fullPath: '/wall/'
      preLoaderRoute: typeof WallIndexRouteImport
      parentRoute: typeof WallRoute
    }
    '/wall/contact': {
      id: '/wall/contact'
      path: '/contact'
      fullPath: '/wall/contact'
      preLoaderRoute: typeof WallContactRouteImport
      parentRoute: typeof WallRoute
    }
    '/wall/soc': {
      id: '/wall/soc'
      path: '/soc'
      fullPath: '/wall/soc'
      preLoaderRoute: typeof WallSocRouteImport
      parentRoute: typeof WallRoute
    }
    '/_app/approvals/': {
      id: '/_app/approvals/'
      path: '/approvals'
      fullPath: '/approvals/'
      preLoaderRoute: typeof AppApprovalsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/approvals/$requestId': {
      id: '/_app/approvals/$requestId'
      path: '/approvals/$requestId'
      fullPath: '/approvals/$requestId'
      preLoaderRoute: typeof AppApprovalsRequestIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cases/': {
      id: '/_app/cases/'
      path: '/cases'
      fullPath: '/cases/'
      preLoaderRoute: typeof AppCasesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cases/$caseId': {
      id: '/_app/cases/$caseId'
      path: '/cases/$caseId'
      fullPath: '/cases/$caseId'
      preLoaderRoute: typeof AppCasesCaseIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/changes/': {
      id: '/_app/changes/'
      path: '/changes'
      fullPath: '/changes/'
      preLoaderRoute: typeof AppChangesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/changes/$requestId': {
      id: '/_app/changes/$requestId'
      path: '/changes/$requestId'
      fullPath: '/changes/$requestId'
      preLoaderRoute: typeof AppChangesRequestIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/': {
      id: '/_app/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppCustomersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/$customerId': {
      id: '/_app/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AppCustomersCustomerIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/issues/': {
      id: '/_app/issues/'
      path: '/issues'
      fullPath: '/issues/'
      preLoaderRoute: typeof AppIssuesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/issues/$issueId': {
      id: '/_app/issues/$issueId'
      path: '/issues/$issueId'
      fullPath: '/issues/$issueId'
      preLoaderRoute: typeof AppIssuesIssueIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/partners/': {
      id: '/_app/partners/'
      path: '/partners'
      fullPath: '/partners/'
      preLoaderRoute: typeof AppPartnersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/partners/$partnerId': {
      id: '/_app/partners/$partnerId'
      path: '/partners/$partnerId'
      fullPath: '/partners/$partnerId'
      preLoaderRoute: typeof AppPartnersPartnerIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/staff/': {
      id: '/_app/staff/'
      path: '/staff'
      fullPath: '/staff/'
      preLoaderRoute: typeof AppStaffIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/staff/$staffId': {
      id: '/_app/staff/$staffId'
      path: '/staff/$staffId'
      fullPath: '/staff/$staffId'
      preLoaderRoute: typeof AppStaffStaffIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/transactions/': {
      id: '/_app/transactions/'
      path: '/transactions'
      fullPath: '/transactions/'
      preLoaderRoute: typeof AppTransactionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/transactions/$transactionId': {
      id: '/_app/transactions/$transactionId'
      path: '/transactions/$transactionId'
      fullPath: '/transactions/$transactionId'
      preLoaderRoute: typeof AppTransactionsTransactionIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/credit/$walletId': {
      id: '/_app/customers/credit/$walletId'
      path: '/customers/credit/$walletId'
      fullPath: '/customers/credit/$walletId'
      preLoaderRoute: typeof AppCustomersCreditWalletIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAlertsRoute: typeof AppAlertsRoute
  AppAuditRoute: typeof AppAuditRoute
  AppCountriesRoute: typeof AppCountriesRoute
  AppExportsRoute: typeof AppExportsRoute
  AppFeesRoute: typeof AppFeesRoute
  AppLimitsRoute: typeof AppLimitsRoute
  AppMoneyRoute: typeof AppMoneyRoute
  AppNoticesRoute: typeof AppNoticesRoute
  AppReferralRewardsRoute: typeof AppReferralRewardsRoute
  AppReferralsRoute: typeof AppReferralsRoute
  AppRegistryRoute: typeof AppRegistryRoute
  AppSecurityRoute: typeof AppSecurityRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppSwitchesRoute: typeof AppSwitchesRoute
  AppTiersRoute: typeof AppTiersRoute
  AppVerificationsRoute: typeof AppVerificationsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppApprovalsRequestIdRoute: typeof AppApprovalsRequestIdRoute
  AppCasesCaseIdRoute: typeof AppCasesCaseIdRoute
  AppChangesRequestIdRoute: typeof AppChangesRequestIdRoute
  AppCustomersCustomerIdRoute: typeof AppCustomersCustomerIdRoute
  AppIssuesIssueIdRoute: typeof AppIssuesIssueIdRoute
  AppPartnersPartnerIdRoute: typeof AppPartnersPartnerIdRoute
  AppStaffStaffIdRoute: typeof AppStaffStaffIdRoute
  AppTransactionsTransactionIdRoute: typeof AppTransactionsTransactionIdRoute
  AppApprovalsIndexRoute: typeof AppApprovalsIndexRoute
  AppCasesIndexRoute: typeof AppCasesIndexRoute
  AppChangesIndexRoute: typeof AppChangesIndexRoute
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute
  AppIssuesIndexRoute: typeof AppIssuesIndexRoute
  AppPartnersIndexRoute: typeof AppPartnersIndexRoute
  AppStaffIndexRoute: typeof AppStaffIndexRoute
  AppTransactionsIndexRoute: typeof AppTransactionsIndexRoute
  AppCustomersCreditWalletIdRoute: typeof AppCustomersCreditWalletIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAlertsRoute: AppAlertsRoute,
  AppAuditRoute: AppAuditRoute,
  AppCountriesRoute: AppCountriesRoute,
  AppExportsRoute: AppExportsRoute,
  AppFeesRoute: AppFeesRoute,
  AppLimitsRoute: AppLimitsRoute,
  AppMoneyRoute: AppMoneyRoute,
  AppNoticesRoute: AppNoticesRoute,
  AppReferralRewardsRoute: AppReferralRewardsRoute,
  AppReferralsRoute: AppReferralsRoute,
  AppRegistryRoute: AppRegistryRoute,
  AppSecurityRoute: AppSecurityRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppSwitchesRoute: AppSwitchesRoute,
  AppTiersRoute: AppTiersRoute,
  AppVerificationsRoute: AppVerificationsRoute,
  AppIndexRoute: AppIndexRoute,
  AppApprovalsRequestIdRoute: AppApprovalsRequestIdRoute,
  AppCasesCaseIdRoute: AppCasesCaseIdRoute,
  AppChangesRequestIdRoute: AppChangesRequestIdRoute,
  AppCustomersCustomerIdRoute: AppCustomersCustomerIdRoute,
  AppIssuesIssueIdRoute: AppIssuesIssueIdRoute,
  AppPartnersPartnerIdRoute: AppPartnersPartnerIdRoute,
  AppStaffStaffIdRoute: AppStaffStaffIdRoute,
  AppTransactionsTransactionIdRoute: AppTransactionsTransactionIdRoute,
  AppApprovalsIndexRoute: AppApprovalsIndexRoute,
  AppCasesIndexRoute: AppCasesIndexRoute,
  AppChangesIndexRoute: AppChangesIndexRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
  AppIssuesIndexRoute: AppIssuesIndexRoute,
  AppPartnersIndexRoute: AppPartnersIndexRoute,
  AppStaffIndexRoute: AppStaffIndexRoute,
  AppTransactionsIndexRoute: AppTransactionsIndexRoute,
  AppCustomersCreditWalletIdRoute: AppCustomersCreditWalletIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface WallRouteChildren {
  WallContactRoute: typeof WallContactRoute
  WallSocRoute: typeof WallSocRoute
  WallIndexRoute: typeof WallIndexRoute
}

const WallRouteChildren: WallRouteChildren = {
  WallContactRoute: WallContactRoute,
  WallSocRoute: WallSocRoute,
  WallIndexRoute: WallIndexRoute,
}

const WallRouteWithChildren = WallRoute._addFileChildren(WallRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  SetPasswordRoute: SetPasswordRoute,
  SignInRoute: SignInRoute,
  WallRoute: WallRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
